import React, { useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "lib/themes/theme";
import PageHeader from "Components/Module/PageHeader";
import withLanguageContext from "lib/hocs/withLanguageContext";
import LearningCatalogueProvider from "./context/provider";
import { useLearningCatalogue } from "./context";
import { CATALOGUE_PAGE_SIZE } from "./constants";
import MobileLayout from "./components/MobileLayout";
import DesktopLayout from "./components/DesktopLayout";

const LearningCatalogueContent = ({ languageContext }) => {
  const learningcatalogue = useLearningCatalogue();
  const { state } = learningcatalogue;
  const { initializeData, setPage, resetFilters } = learningcatalogue;
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Use ref to track if data has been initialized
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current) {
      initializeData();
      initializedRef.current = true;
    }
  }, [initializeData]);

  const maxPages =
    Math.ceil(
      state.learningActivities &&
        state.learningActivities.totalAmountOfCourses / CATALOGUE_PAGE_SIZE,
    ) || 0;

  const shouldShowPagination =
    !state.listView &&
    state.learningActivities?.filteredCourses?.length &&
    maxPages > 1;

  return (
    <>
      <PageHeader pageTitle={languageContext("coursecatalogue")} />
      {isMobile ? (
        <MobileLayout
          state={state}
          languageContext={languageContext}
          resetFilters={resetFilters}
        />
      ) : (
        <DesktopLayout
          state={state}
          languageContext={languageContext}
          resetFilters={resetFilters}
          shouldShowPagination={shouldShowPagination}
          maxPages={maxPages}
          setPage={setPage}
        />
      )}
    </>
  );
};

const LearningCatalogue = ({ languageContext, public: isPublic = false }) => {
  return (
    <ThemeProvider theme={theme}>
      <LearningCatalogueProvider public={isPublic}>
        <LearningCatalogueContent languageContext={languageContext} />
      </LearningCatalogueProvider>
    </ThemeProvider>
  );
};

export default withLanguageContext(LearningCatalogue, "Activities");
